
import Dialog from '@ohrm/oxd/core/components/Dialog/Dialog';
import TrainingPlanEdit from '../../../orangehrmTrainigPlugin/pages/training/TrainingPlanEdit';
export default {
  components: {
    'oxd-dialog': Dialog,
    TrainingPlanEdit: TrainingPlanEdit,
  },
  props: {
    departments: {type: Array, default: () => []},
  },
  data() {
    return {
      show: false,
      reject: null,
      resolve: null,
    };
  },
  methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.show = true;
      });
    },
    afterSubmit(trainingData) {
      this.show = false;
      this.resolve && this.resolve(trainingData);
    },
    onCancel() {
      this.show = false;
      this.resolve && this.reject('cancel');
    },
  },
};
